/** Shared breakpoint for sidebar ↔ drawer switch (matches shell layouts). */
export const WORKSPACE_LAYOUT_BREAKPOINT_PX = 900;

/** Sidebar width — icon rail (~64px). */
export const WORKSPACE_SIDEBAR_WIDTH = '4rem';

/** Hover-expanded sidebar width (overlays content; desktop only). */
export const WORKSPACE_SIDEBAR_EXPANDED_WIDTH = '15rem';

/** Labels and headings that fade in while the hover-expand sidebar is open. */
export const WORKSPACE_SIDEBAR_REVEAL_CLASS =
  'opacity-0 transition-opacity duration-150 min-[901px]:group-hover/sidebar:opacity-100 min-[901px]:group-has-[:focus-visible]/sidebar:opacity-100';

/** Compact header / brand-row height — matched to mock. */
export const WORKSPACE_HEADER_HEIGHT = '3.31rem';

/** Sidebar brand row — same height and bottom edge as TopNavBar. */
export const WORKSPACE_BRAND_ROW_CLASS =
  'box-border flex h-[var(--workspace-header-height)] shrink-0 items-center overflow-hidden border-0 border-b border-solid border-[var(--inv-border)] bg-[var(--inv-bg)] px-4';

export const WORKSPACE_SIDEBAR_BG_CLASS = 'bg-[var(--inv-sidebar-bg)]';

export const WORKSPACE_SIDEBAR_BORDER_CLASS =
  'border-[var(--inv-sidebar-border)]';

export const WORKSPACE_SIDEBAR_DIVIDER_CLASS =
  'my-2 h-px w-6 shrink-0 bg-[var(--inv-sidebar-divider)]';

/** Icon-only mark for the sidebar rail — left crop of the full logo (no wordmark). */
export const WORKSPACE_SIDEBAR_BRAND_ICON_SRC = `${import.meta.env.BASE_URL}assets/images/qtraceai-logo.png`;

export const WORKSPACE_SIDEBAR_BRAND_ICON_CLIP_CLASS =
  'h-9 w-9 shrink-0 overflow-hidden transition-[width] duration-200 ease-out min-[901px]:group-hover/sidebar:w-[9rem]';

export const WORKSPACE_SIDEBAR_BRAND_ICON_IMG_CLASS =
  'block h-7 w-auto max-w-none object-contain object-left brightness-0 invert';

export const WORKSPACE_SIDEBAR_AVATAR_CLASS =
  'flex h-9 w-9 items-center justify-center rounded-full border-0 bg-[var(--inv-accent)] p-0 text-[0.6875rem] font-bold text-[var(--inv-on-accent)] hover:bg-[var(--inv-accent-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--inv-accent-ring)]';

const workspaceSidebarNavStateClass = (active: boolean): string =>
  active
    ? 'bg-[var(--inv-sidebar-nav-active)] text-[var(--inv-sidebar-fg)] hover:bg-[var(--inv-sidebar-nav-active)] hover:text-[var(--inv-sidebar-fg)]'
    : 'bg-transparent text-[var(--inv-sidebar-icon)] hover:bg-[var(--inv-sidebar-nav-hover)] hover:text-[var(--inv-sidebar-fg)]';

export const workspaceSidebarNavBtnClass = (active: boolean): string =>
  [
    'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border-0 p-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--inv-accent-ring)]',
    workspaceSidebarNavStateClass(active),
  ].join(' ');

/** Full-width nav row: 36px icon cell at the left, label revealed on expand. */
export const workspaceSidebarNavRowClass = (active: boolean): string =>
  [
    'flex h-9 w-full min-w-0 shrink-0 items-center justify-start gap-0 overflow-hidden rounded-lg border-0 p-0 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--inv-accent-ring)]',
    workspaceSidebarNavStateClass(active),
  ].join(' ');